module.exports = {
  // Disabled state of BRAND_HEADER_CONTRAST_WEAK
  brandHeaderContrastWeakDisabled: 'rgba(166, 166, 166, 0.25)',
  // Gray Color 11
  colorGray11: 'rgb(62, 62, 60)',
  // Transparent value of BRAND_PRIMARY at 10%
  brandPrimaryTransparent10: 'rgba(21, 137, 238, 0.1)',
  // Gray Color 12
  colorGray12: 'rgb(43, 40, 38)',
  // These RGBA values need to be updated if BRAND_BACKGROUND_DARK changes, solves webkit bug
  brandBackgroundDarkTransparent: 'rgba(221, 219, 218, 0)',
  // Background color a branded app header
  brandHeader: 'rgb(255, 255, 255)',
  // Active / Hover state of BRAND_LIGHT
  brandLightActive: 'rgb(227, 229, 237)',
  // Variant of BRAND_HEADER_CONTRAST that provides a warm color
  brandHeaderContrastWarm: 'rgb(191, 2, 1)',
  // Disabled state of BRAND_HEADER_ICON
  brandHeaderIconDisabled: 'rgba(145, 145, 145, 0.25)',
  // Active / Hover state of BRAND_HEADER_CONTRAST
  brandHeaderContrastActive: 'rgb(80, 80, 80)',
  // Primary page background color
  brandBackgroundPrimary: 'rgb(250, 250, 249)',
  // Primary brand color
  brandPrimary: 'rgb(21, 137, 238)',
  // Active / Hover state of BRAND_HEADER_CONTRAST_WEAK
  brandHeaderContrastWeakActive: 'rgb(129, 129, 129)',
  // Active / Hover state of BRAND_CONTRAST
  brandContrastActive: 'rgb(13, 14, 18)',
  // Variant of BRAND_HEADER_CONTRAST that provides a cool color
  brandHeaderContrastCool: 'rgb(0, 85, 131)',
  // Variant of BRAND_HEADER that is accessible with BRAND_HEADER
  brandHeaderContrastInverse: 'rgb(255, 255, 255)',
  // Dark variant of BRAND that is accessible with light colors
  brandDark: 'rgb(24, 35, 55)',
  // Dark variant of BRAND that is accessible with white
  brandAccessible: 'rgb(0, 112, 210)',
  // Dark variant of BRAND_BACKGROUND_PRIMARY, used within gradient of background color
  brandBackgroundDark: 'rgb(232, 232, 232)',
  // Active / Hover state of BRAND_TEXT_LINK
  brandTextLinkActive: 'rgb(0, 95, 178)',
  // Gray Color 1
  colorGray1: 'rgb(255, 255, 255)',
  // Gray Color 2
  colorGray2: 'rgb(250, 250, 249)',
  // Active / Hover state of BRAND_HEADER_ICON
  brandHeaderIconActive: 'rgb(129, 129, 129)',
  // Gray Color 3
  colorGray3: 'rgb(243, 242, 242)',
  // Icons of BRAND_HEADER that is accessible with BRAND_HEADER
  brandHeaderIcon: 'rgb(145, 145, 145)',
  // Disabled state of BRAND_A11Y
  brandDisabled: 'rgb(201, 199, 197)',
  // Primary text link brand color
  brandTextLink: 'rgb(0, 109, 204)',
  // Gray Color 4
  colorGray4: 'rgb(236, 235, 234)',
  // Gray Color 5
  colorGray5: 'rgb(221, 219, 218)',
  // Gray Color 6
  colorGray6: 'rgb(201, 199, 197)',
  // Active / Hover state of BRAND_A11Y
  brandAccessibleActive: 'rgb(0, 95, 178)',
  // Gray Color 7
  colorGray7: 'rgb(176, 173, 171)',
  // Active / Hover state of BRAND_DARK
  brandDarkActive: 'rgb(37, 48, 69)',
  // Gray Color 8
  colorGray8: 'rgb(150, 148, 146)',
  // Active / Hover state of BRAND_HEADER_CONTRAST
  brandHeaderContrastInverseActive: 'rgb(238, 238, 238)',
  // Active / Hover state of BRAND_HEADER_CONTRAST_COOL
  brandHeaderContrastCoolActive: 'rgb(0, 85, 131)',
  // Gray Color 9
  colorGray9: 'rgb(112, 110, 107)',
  // Variant of BRAND that is accessible with BRAND
  brandContrast: 'rgb(26, 27, 30)',
  // Weak contrast ratio, useful for iconography
  brandHeaderContrastWeak: 'rgb(145, 145, 145)',
  // Active / Hover state of BRAND_PRIMARY
  brandPrimaryActive: 'rgb(0, 122, 221)',
  // These RGBA values need to be updated if BRAND_BACKGROUND_PRIMARY changes, solves webkit bug
  brandBackgroundPrimaryTransparent: 'rgba(250, 250, 249, 0)',
  // Variant of BRAND_HEADER that is accessible with BRAND_HEADER
  brandHeaderContrast: 'rgb(94, 94, 94)',
  // Transparent value of BRAND_PRIMARY
  brandPrimaryTransparent: 'rgba(21, 137, 238, 0.1)',
  // Active / Hover state of BRAND_HEADER_CONTRAST_WARM
  brandHeaderContrastWarmActive: 'rgb(172, 0, 0)',
  // Transparent value of BRAND_PRIMARY at 40%
  brandPrimaryTransparent40: 'rgba(21, 137, 238, 0.4)',
  // Light variant of BRAND that is accessible with dark colors
  brandLight: 'rgb(244, 246, 254)',
  // Gray Color 10
  colorGray10: 'rgb(81, 79, 77)'
};
//# sourceMappingURL=palette-colors.common.js.map